module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_MU_2Bdr_D4_cam5.0c44e649.jpg";